import { createFileRoute, redirect } from "@tanstack/react-router";

// /go fue la versión previa de la portada: hoy es la home principal.
export const Route = createFileRoute("/go")({
  beforeLoad: () => {
    throw redirect({ to: "/", statusCode: 301 });
  },
});
